import { render } from "./EditOrder.vue?vue&type=template&id=4bc0947f&scoped=true"
import script from "./EditOrder.vue?vue&type=script&lang=js"
export * from "./EditOrder.vue?vue&type=script&lang=js"

import "./EditOrder.vue?vue&type=style&index=0&id=4bc0947f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc0947f"]])

export default __exports__